











































import { Component, Prop, Vue } from 'vue-property-decorator';
import Equation from '@/components/Equation.vue';
import { ClimbAngleConstraint } from '@/interfaces/constraints';

@Component({
  components: {
  Equation,
  }
  })
export default class ClimbAngleFields extends Vue {
  @Prop() constraint!: ClimbAngleConstraint;
}
